import React, { useState } from 'react';

import NoticesByInstance from "../tables/noticesByInstance";
import LineChartHistoricNotices from "../graphs/lineChartHistoricNotices";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import NavBarMenu from '../NavBarMenu';
import FooterMenu from '../FooterMenu';

export default function Notices() {
    const [value, setValue] = useState(30);
    const handleChanges = (newValue) => {
        setValue(newValue) 
    }

    const [instance, setInstance] = useState();
    const handleInstanceChanges = (newInstance) => {
        setInstance(newInstance) 
    }

    return (
      <>
        <NavBarMenu handleInstanceChanges={handleInstanceChanges} handler={handleChanges} />
        <main>
            <Container fluid>
                <Row className="display-flex">
                    <Col>
                        <LineChartHistoricNotices/>
                    </Col>
                </Row>
                <Row className="display-flex">
                    <Col >
                        <NoticesByInstance instance={instance} value={value}/>
                    </Col>
                </Row>
            </Container>
        </main>
        <FooterMenu />
      </>
    );
}